// extracted by mini-css-extract-plugin
export const footer = "footer-module--footer--2p1NW";
export const icon = "footer-module--icon--1hEqU";